import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import api from '../services/api';

const QuestionnaireRoute = ({ children }) => {
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkQuestionnaireAccess = async () => {
      // Проверяем наличие токена для анкеты
      const questionnaireToken = sessionStorage.getItem('questionnaire_token');
      
      if (questionnaireToken) {
        // Устанавливаем токен для запросов
        api.defaults.headers.common['Authorization'] = `Bearer ${questionnaireToken}`;
        
        // Проверяем, что токен валиден (пробуем сделать запрос)
        try {
          // Можно проверить через любой endpoint анкеты или просто установить как авторизованного
          setIsAuthorized(true);
        } catch (error) {
          setIsAuthorized(false);
          sessionStorage.removeItem('questionnaire_token');
        }
      } else {
        setIsAuthorized(false);
      }
      
      setLoading(false);
    };

    checkQuestionnaireAccess();
  }, []);

  if (loading) {
    return <div>Загрузка...</div>;
  }

  return isAuthorized ? children : <Navigate to="/register/teacher" replace />;
};

export default QuestionnaireRoute;
